import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./index.css";

const RESIZE_OBSERVER_LOOP_ERROR = "ResizeObserver loop completed with undelivered notifications.";

window.addEventListener("error", (event) => {
  if (event?.message === RESIZE_OBSERVER_LOOP_ERROR) {
    event.stopImmediatePropagation();
  }
});

window.addEventListener("unhandledrejection", (event) => {
  const reasonMessage = event?.reason?.message || event?.reason;
  if (reasonMessage === RESIZE_OBSERVER_LOOP_ERROR) {
    event.preventDefault();
  }
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
